<template>
  <div class="row">
    <div class="col-3">
      <h3>Vertical Image</h3>
      <app-placeholder-vertical :imageId="form.imageId" @upload="onUpload"/>
    </div>
  </div>
</template>

<script>
import AppPlaceholderVertical from '@/components/App/AppPlaceholderVertical'

export default {
  components: {
    AppPlaceholderVertical,
  },

  props: {
    recipe: Object,
  },

  data() {
    return {
      form: {
        imageId: this.recipe.image_v_id,
      }
    }
  },

  methods: {
    async onUpload(imageId) {
      try {
        var { data } = await this.$http.put(`/recipes/${ this.recipe.id }`, {
          image_v_id: imageId,
        })
      } catch(err) {
        this.$message.error(err.response.data.message)
        return false
      }

      this.form.imageId = imageId
      this.$message.success(data.message)
    },
  },
}
</script>
